import { render, staticRenderFns } from "./HeadlineBig.vue?vue&type=template&id=f62f8320&scoped=true&"
import script from "./HeadlineBig.vue?vue&type=script&lang=js&"
export * from "./HeadlineBig.vue?vue&type=script&lang=js&"
import style0 from "./HeadlineBig.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HeadlineBig.vue?vue&type=style&index=1&id=f62f8320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62f8320",
  null
  
)

export default component.exports